export default {
	18_24: 'Entre 18 e 24 anos',
	25_30: 'Entre 25 e 30 anos',
	31_40: 'Entre 31 e 40 anos',
	41_50: 'Entre 41 e 50 anos',
	51_60: 'Entre 51 e 60 anos',
	'60_plus': 'Mais de 60 anos',
	you_dont_have_this_badge_yet: 'Você ainda não tem esta medalha',
	you_got_this_badge_on: 'Você ganhou esta medalha em',
	accept_terms_and_conditions: 'Eu aceito os termos e condições',
	accept_terms: 'Aceitar termos',
	access_the_website_from_the: 'Acesse seu perfil do',
	activity_feed: 'Feed Atividades',
	age: 'Idade',
	approved: 'Aprovado',
	are_you_a_painter: 'Você é um pintor?',
	avatar_photo_optional: 'Avatar/Foto (opcional)',
	awaiting_approval: 'Aguardando Aprovação',
	birthday: 'Aniversário',
	birthday_date: 'Data de nascimento',
	birthday_date_hint:
		'Para alterar é necessário editar todos os dados (ano/mês/dia).',
	born_in: 'Aniversário em',
	branch: 'Loja',
	brand: 'Marca',
	cellphone: 'Celular',
	change_avatar: 'Alterar Avatar',
	change_phone: 'Trocar número',
	verification_code_sent:	'Código de verificação enviado',
	error_sending_verification_code: 'Erro ao enviar código de verificação',
	change_password: 'Alterar senha',
	children: 'Filhos',
	city: 'Cidade',
	commercial_phone: 'Telefone Comercial',
	company_agency: 'Empresa/Agência',
	complement: 'Complemento',
	communication_phone: 'Telefone de comunicação',
	confirm_password: 'Confirmar senha',
	contact_information: 'Informações de Contato',
	country: 'País',
	current_password: 'Senha atual',
	delivered: 'Entregue',
	document_not_unique: 'Documento já utilizado',
	each_level_has_exclusive_benefits_check_out_the:
		'Confira os benefícios de cada nível do programa.',
	email_confirm: 'Confirmar Email',
	email_dont_match: 'Emails não conferem',
	email_receipt_change_successfully_changed:
		'Alteração do recebimento de emails alterada com sucesso',
	error_changing_password_check_your_current_password_or_try_again_later:
		'Erro ao alterar senha. Verifique a senha atual ou tente novamente mais tarde',
	event_checkin: 'Check-in no evento',
	event_qrcode_checkin: 'Evento',
	female: 'Feminino',
	file_upload_reproval: 'Envio de foto reprovada',
	file_upload: 'Envio de foto',
	from: 'de',
	gender: 'Gênero',
	general: 'Geral',
	gmin_number: 'Número GMIN',
	go_to_reward_store: 'Ir para Loja de Recompensas',
	handicap_description: 'Descrição da necessidade especial',
	i_agree_to_receive_interesting_emails_and_recommendations:
		'Aceito receber emails interessantes e recomendações',
	i_wish_to_receive_emails_from_intel_rewards_you_program:
		'Desejo receber comunicações por e-mail do programa Intel Te Premia',
	inbox: 'Mensagens',
	information: 'Informações',
	intel_retail_edge_program: 'Programa Intel® Retail Edge',
	invalid_phone: 'Telefone inválido',
	is_handicapped: 'Portador de necessidades especiais?',
	justification: 'Justificativa',
	kdv_code: 'Código CADV',
	last_name: 'Sobrenome',
	level_up: 'Upgrade',
	male: 'Masculino',
	marital_status: 'Estado Civil',
	message: 'Mensagem',
	mobile_phone: 'Telefone Celular',
	more_than: 'mais de',
	my_data: 'Meus Dados',
	my_points: 'Meus Pontos',
	name: 'Nome',
	neighborhood: 'Bairro',
	new_password: 'Nova senha',
	nickname: 'Apelido',
	no_address_found: 'Nenhum endereço encontrado',
	no_certificates_available: 'Nenhum certificado disponível',
	no_events_in_your_activity_feed_come_back_later:
		'Nenhum acontecimento no seu feed de atividades. Volte mais tarde.',
	number_of_children: 'Número de filhos',
	number: 'Número',
	open_points_history: 'Abrir histórico de pontos',
	open_points_statement: 'Abrir extrato de pontos',
	order_history: 'Histórico do Pedido',
	order: 'Pedido',
	orders: 'Meus Resgates',
	others: 'Outros',
	painter: 'Pintor',
	password_changed_successfully: 'Senha alterada com sucesso',
	past_months: 'Meses anteriores',
	personal_information: 'Informações Pessoais',
	phone_number: 'Telefone',
	phone: 'Telefone',
	phone_verified: 'Telefone verificado',
	phone_social_information: 'Necessário confirmação',
	phone_not_verified: 'Telefone não verificado. Verifique a mensagem de validação do número em seu WhatsApp.',
	phone_to_receive_notifications_promotions_and_account_settings: 'Telefone para receber avisos, convites e recuperação de conta.',
	points_earned_during_the_campaign: 'Pontos ganhos durante a campanha',
	profession: 'Profissão',
	professional_information: 'Informações profissionais',
	profile_edited_successfully: 'Perfil editado com sucesso',
	profile_successfully_changed: 'Perfil alterado com sucesso',
	program_rule: 'regra do programa',
	redeem: 'Resgate',
	resend_verification: 'Reenviar verificação',
	register: 'Registro',
	reject_terms: 'Rejeitar termos',
	reproved: 'Reprovado',
	residential_phone: 'Telefone Residencial',
	retailer: 'Rede Varejista',
	sale_reproval: 'Venda reprovada',
	sale: 'Vendas',
	search_address: 'Buscar endereço',
	search_by_street_name_and_number: 'Busque pelo nome da rua e número',
	see_all_badges: 'Ver todas as medalhas',
	see_all_certificates: 'Ver todos os certificados',
	see_the_full_ranking: 'Ver o ranking completo',
	select_profile: 'Selecione o perfil',
	shipped: 'Enviado',
	show_ranking: 'Ver ranking',
	state: 'Estado',
	statement: 'Extrato',
	store_nickname: 'Apelido na Loja (opcional)',
	there_are_no_messages_available_at_the_moment: 'Não existem mensagem disponíveis no momento',
	these_data_cannot_be_changed: 'Estes dados não podem ser alterados.',
	this_campaign: 'Esta campanha',
	to_change_the_information_bellow: 'se deseja alterar seus dados pessoais.',
	to: 'até',
	total_credits_available_to_spend: 'Total de pontos disponíveis para utilização',
	training_special: 'Bônus de treinamentos obrigatórios',
	type_photo_upload: 'envio de foto do tipo',
	undefined: 'Prefiro não revelar',
	user_avatar_changed: 'Avatar do usuário alterado',
	user_level_up: 'Usuário subiu de nível',
	user_registered: 'Usuário cadastrado',
	wait: 'Aguarde',
	we_couldnt_find_any_messages_with_the_current_search:
		'Não conseguimos localizar nenhuma mensagem com a busca atual.',
	whats_your_profession: 'Qual a sua profissão?',
	whatsapp: 'Whatsapp',
	you_dont_have_any_points_yet: 'Você ainda não possui nenhum ponto',
	you_dont_have_certificates_in_this_category: 'Você ainda não tem certificados nesta categoria',
	you_have: 'você tem',
	your_account_has_been_created_and_is_awaiting_for_aproval_you_will_receive_an_email:
		'Sua conta foi criada e está aguardando aprovação. Você receberá um email assim que ela for aprovada.',
	your_account_has_been_created_verify_your_email_for_instructions:
		'Sua conta foi criada. Verifique o seu email para mais instruções. Não esqueça de checar sua pasta de lixo eletrônico (SPAM)',
	your_password_must_contain_at_least_characters_uppercase_letters_lowercase_letters_numbers_and_symbols:
		'Sua senha deve conter no mínimo 6 caracteres, letras maiúsculas, letras minúsculas, números e símbolos {symbols}',
	your_password_must_contain_at_least_characters_uppercase_letters_lowercase_letters_numbers:
		'Sua senha deve conter no mínimo 6 caracteres, letras maiúsculas, letras minúsculas, números',
	your_password_must_contain_at_least_characters: 'Sua senha deve conter no mínimo 6 caracteres',
	your_ranking_position_will_be_available_after_you_complete_at_least_one_course:
		'Sua posição no ranking estará disponível após você concluir ao menos um curso.',
	find_your_network: 'Encontre sua rede',
	select_your_branch: 'Selecione sua filial',
}
